
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AddBtn from "@/components/generic/buttons/add-btn.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";
import AddKeysModal from "@/components/key-groups/AddKeysModal.vue";
import AddNonTransferablesModal from "@/components/key-groups/AddNonTransferablesModal.vue";

@Component({
  components: { AddNonTransferablesModal, AddKeysModal, SimpleDialog, AddBtn },
})
export default class NonTransferablesTab extends Vue {

  @Prop({default: null})
  public keyGroup: any;

  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private nonTransferables: any[] = [];
  private nonTransferablesHeaders: object[] = [];
  private loadingNonTransferables: boolean = false;
  private addNonTransferableDialog: boolean = false;
  private removedNonTransferable: any = null;
  private showDialogRemoveConfirm: boolean = false;
  private loadingRemove: boolean = false;

  private mounted() {
    this.nonTransferablesHeaders = [
      { value: "name", text: this.$tc("form.name"), sortable: true },
      { value: "provider", text: this.$t("form.provider"), sortable: true },
      { value: "createdAt", text: this.$t("key.createdOn"), sortable: true },
      { value: "actions", sortable: false },
    ];
    this.getNonTransferables();
  }

  private getNonTransferables(): Promise<any> {
    this.loadingNonTransferables = true;
    return this.$store.dispatch("keyGroups/getNonTransferables", {
      id: this.keyGroup?.id,
    }).then((res) => {
      this.nonTransferables = res.rows;
    }).finally(() => {
      this.loadingNonTransferables = false;
      this.$emit("loaded");
    });
  }

  private async removeKey(): Promise<void> {
    this.loadingRemove = true;
    await this.$store.dispatch("keyGroups/removeNonTransferable", {
      groupId: this.keyGroup.id,
      nonTransferableId: this.removedNonTransferable.id,
    }).then(() => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n.t("keyGroup.removeNonTransferable.successMessage"),
      });
      this.cancelRemove();
      this.getNonTransferables();
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loadingRemove = false;
    });
  }

  private initRemove(key) {
    this.removedNonTransferable = key;
    this.showDialogRemoveConfirm = true;
  }

  private cancelRemove() {
    this.showDialogRemoveConfirm = false;
    this.removedNonTransferable = null;
  }

  private rowClick(row) {
    this.$router.push({
      name : "non-transferable",
      params: { id: row.id },
    });
  }
}
